import OpenAPIClientAxios from 'openapi-client-axios';
let brkApiInstance;
async function getBRKApiInstance(store) {
    const brkApiSpecResult = await store.dispatch('getData', { url: '/brk/api-spec' });
    // Backend deliverd a string and not an object as before
    const brkApiSpec = JSON.parse(brkApiSpecResult.data);

    const axiosConfigDefaults = {

        adapter: (config) => {
            const path = '/brk/info';
            return store.dispatch('postData', { url: path, data: config });
        }
    };
    const brkApi = new OpenAPIClientAxios({ definition: brkApiSpec, axiosConfigDefaults });
    brkApi.init();
    return brkApi.getClient();
}

const api = (store) => {
    if (brkApiInstance) {
        return brkApiInstance;
    }
    brkApiInstance = getBRKApiInstance(store);
    return brkApiInstance;
};

export default api;
